'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const UserSettingsStateNames=[
'notificationSettings',
'timelineSettings',
'groups',
'profile',
'organizationProfile',
'organizationUsers',
'terms'].
map(function(featureSubPath){return`fdc.features.${featureSubPath}`});let

UserSettingsButtonDirective=function(_BaseControllerBacked){_inherits(UserSettingsButtonDirective,_BaseControllerBacked);function UserSettingsButtonDirective(){_classCallCheck(this,UserSettingsButtonDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(UserSettingsButtonDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/userSettingsButtonDirective/userSettingsButtonTemplate'}},{key:'controller',get:function()

{return UserSettingsButtonDirectiveController}},{key:'$inject',get:function()

{return['$scope','$state','$timeout','userService','breadcrumbsService']}}]);return UserSettingsButtonDirective}(BaseControllerBackedDirective);let


UserSettingsButtonDirectiveController=function(){
function UserSettingsButtonDirectiveController($scope,$state,$timeout,userService,breadcrumbsService){var _this2=this;_classCallCheck(this,UserSettingsButtonDirectiveController);
this._$scope=$scope;
this._$state=$state;
this._$timeout=$timeout;
this._userService=userService;
this._breadcrumbsService=breadcrumbsService;
this._isHidden=!0;

this._$scope.$watch('controller._userService.currentUser',function(){return _this2._setUserInfo()});
this._setUserInfo();

this._$scope.$watch('controller._$state.current.name',function(){return _this2._refreshButtonState()});
this._refreshButtonState();
}UserSettingsButtonDirectiveController.prototype.

logout=function logout(){var _this3=this;
this._$timeout(function(){
_this3._userService.logout();
_this3._unsetUserInfo();
});
};UserSettingsButtonDirectiveController.prototype.

_setUserInfo=function _setUserInfo(){var _this4=this;
this._$timeout(function(){
if(_.exists(_this4._userService,'currentUser.firstName')&&
_.exists(_this4._userService,'currentUser.lastName')){
const currentUser=_this4._userService.currentUser;
_this4._firstName=currentUser.firstName;
_this4._lastName=currentUser.lastName;
_this4._isHidden=!1;
return;
}

_this4._unsetUserInfo();
});
};UserSettingsButtonDirectiveController.prototype.

_unsetUserInfo=function _unsetUserInfo(){
this._firstName=void 0;
this._lastName=void 0;
this._isHidden=!0;
this._breadcrumbsService.clearCrumbsAndResetWindowTitle();
};UserSettingsButtonDirectiveController.prototype.

_refreshButtonState=function _refreshButtonState(){
this._isInUserSettingsSubState=_(UserSettingsStateNames).includes(this._$state.current.name);
};_createClass(UserSettingsButtonDirectiveController,[{key:'isHidden',get:function()

{
return this._isHidden;
}},{key:'firstName',get:function()

{
return this._firstName;
}},{key:'lastName',get:function()

{
return this._lastName;
}},{key:'isInUserSettingsSubState',get:function()

{
return this._isInUserSettingsSubState;
}}]);return UserSettingsButtonDirectiveController}();



module.exports=UserSettingsButtonDirective;
//# sourceMappingURL=userSettingsButtonDirective.js.map
